import React, { memo, useMemo } from "react";
import TableCustomCmv from "../../../../../components/MyCustom/TableCustomCmv";
import Spinner from "../../../../../components/bootstrap/Spinner";
import Money from "../../../../../helpers/utils/money/money";
import useCmvProducts from "../../../../../hooks/reports/useCmvProducts";
import useDarkMode from "../../../../../hooks/useDarkMode";
import dateFormat from "dateformat";
import RankingPorCusto from "../../../../../components/RankingPorCusto";

const TabInsumo = ({ hidden, dataFilter }) => {
    const { darkModeStatus } = useDarkMode()
    const { rows, loading } = useCmvProducts(dataFilter)

    const days = Array.from({ length: 31 }, (_, i) => {
        const day = String(i + 1).padStart(2, '0');
        return [
            {
                label: `${day} - Qtd`,
                field: `{row}`,
                formatExport: (row) => row?.days[day]?.totalQuantity ?? 0,
                hidden: true,
            },
            {
                label: `${day} - Cmv`,
                field: `{row}`,
                formatExport: (row) => {
                    const total = row?.days[day]?.totalCoust ?? 0;
                    const qtd = row?.days[day]?.totalQuantity ?? 0
                    const cmv = qtd > 0 ? total / qtd : 0;
                    return Money.centsToCoinCsv(cmv)
                },
                isCurrency: true,
                hidden: true,
            }
        ];
    }).flat();

    const columns = useMemo(() => [
        {
            label: 'Tipo',
            field: 'type'
        },
        {
            label: 'Última Alteração',
            field: 'lastInsumeModified',
            format: ({ lastInsumeModified }) => {
                return lastInsumeModified
                    ? dateFormat(
                        new Date(
                            lastInsumeModified._seconds * 1000 +
                            Math.floor(lastInsumeModified._nanoseconds / 1e6)
                        ),
                        'dd/mm/yyyy HH:MM'
                    )
                    : '-'
            },
            isDate: true,
            noExport: true
        },
        {
            label: 'Nome',
            field: 'name',
        },
        {
            label: 'Unidade',
            field: 'unit',
        },
        ...days,
        {
            label: 'QTD. Total',
            field: 'totalQtd'
        },
        {
            label: 'Total',
            field: 'total',
            format: row => Money.centsToMaskMoney(row.total),
            isCurrency: true
        },
        {
            label: 'Custo Total',
            field: 'totalCost',
            format: row => Money.centsToMaskMoney(row.totalCost),
            isCurrency: true
        },
        {
            label: 'CMV',
            field: '{row}',
            format: row => Money.centsToMaskMoney(row.totalCost / row.totalQtd),
            formatExport: row => (row.totalCost / row.totalQtd),
            isCurrency: true
        },
        {
            label: 'CMV (%)',
            field: '{row}',
            format: row => {
                if (!row.total || row.total === 0) return "0%"
                const perc = (row.totalCost / row.total) * 100
                return perc.toFixed(2) + " %"
            },
            isPercentage: true
        },
    ], [darkModeStatus, days])

    return (
        <div hidden={hidden}>
            {loading ? (
                <div className="d-flex flex-column justify-content-center align-items-center h-100">
                    <Spinner
                        className='text-center'
                        color='blue'
                        size={72}
                        tag='span'
                    />
                </div>
            ) : (
                <div className="row g-3">
                    <div className="col-12 d-flex">
                        <div className="card shadow-sm p-3 w-100 h-100">
                            <TableCustomCmv
                                titlePdf="cmv-produto"
                                icon="TableChart"
                                fontSize={8}
                                rows={rows}
                                columns={columns}
                                fileName="CMV-Produto"
                            />
                        </div>
                    </div>

                    {/* <div className="col-12 col-md-6 d-flex">
                    <div className="card shadow-sm p-3 w-100 h-100">
                        <RankingPorCusto dataFilter={dataFilter} />
                    </div>
                </div> */}
                </div>
            )}
        </div>
    );

}

export default memo(TabInsumo)